import { render } from "./PartnerCollective.vue?vue&type=template&id=472b21e6"
import script from "./PartnerCollective.vue?vue&type=script&lang=js"
export * from "./PartnerCollective.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__